module.exports = __webpack_public_path__ + "aa7660e8fa65d54c1dc821ce66b5fb36.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/cow.png
// module id = 3166
// module chunks = 0